export const PRIMARY_CEMAIL_TYPE = "P";
export const OTHER_CEMAIL_TYPE = "O";

export const INVALID_CEMAIL_KEYWORD = "Invalid Email";

export const MFA_MESSAGE = "loginSecurity:mfaEnrolled.message";

export const SSO_SUPPRESSION = ["username", "lastLogin"];

export const ERROR1 = "Something went wrong. Please try again later.";

export const ERROR_500 = "500 INTERNAL_SERVER_ERROR";

export const ERROR_RESTRICT_COOKIE = "The ability to update your profile is not available at this time. For assistance, please contact Customer Service at (800) 722-4448; in New York call (800) 748-6907 and provide this error code (4OAS).";

export const PHONE_TYPE = [
    { value: "sms", label: "Text/SMS" },
    { value: "call", label: "Voice Call" }
]

export const US_STATES_ABBREV = {
    Alabama: "AL",
    Alaska: "AK",
    Arizona: "AZ",
    Arkansas: "AR",
    California: "CA",
    Colorado: "CO",
    Connecticut: "CT",
    Delaware: "DE",
    Florida: "FL",
    Georgia: "GA",
    Hawaii: "HI",
    Idaho: "ID",
    Illinois: "IL",
    Indiana: "IN",
    Iowa: "IA",
    Kansas: "KS",
    Kentucky: "KY",
    Louisiana: "LA",
    Maine: "ME",
    Maryland: "MD",
    Massachusetts: "MA",
    Michigan: "MI",
    Minnesota: "MN",
    Mississippi: "MS",
    Missouri: "MO",
    Montana: "MT",
    Nebraska: "NE",
    Nevada: "NV",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    "New York": "NY",
    "North Carolina": "NC",
    "North Dakota": "ND",
    Ohio: "OH",
    Oklahoma: "OK",
    Oregon: "OR",
    Pennsylvania: "PA",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    Tennessee: "TN",
    Texas: "TX",
    Utah: "UT",
    Vermont: "VT",
    Virginia: "VA",
    Washington: "WA",
    "Washington DC": "DC",
    "West Virginia": "WV",
    Wisconsin: "WI",
    Wyoming: "WY"
};

export const COUNTRIES = [
    { value: "+1", label: "United States" },
    { value: "+355", label: "Albania" },
    { value: "+1", label: "American Samoa" },
    { value: "+376", label: "Andorra" },
    { value: "+244", label: "Angola" },
    { value: "+1", label: "Anguilla" },
    { value: "+1", label: "Antigua and Barbuda" },
    { value: "+54", label: "Argentina" },
    { value: "+374", label: "Armenia" },
    { value: "+297", label: "Aruba" },
    { value: "+61", label: "Australia" },
    { value: "+43", label: "Austria" },
    { value: "+994", label: "Azerbaijan" },
    { value: "+1", label: "Bahamas" },
    { value: "+973", label: "Bahrain" },
    { value: "+880", label: "Bangladesh" },
    { value: "+1", label: "Barbados" },
    { value: "+32", label: "Belgium" },
    { value: "+501", label: "Belize" },
    { value: "+229", label: "Benin" },
    { value: "+1", label: "Bermuda" },
    { value: "+975", label: "Bhutan" },
    { value: "+591", label: "Plurinational State of Bolivia" },
    { value: "+387", label: "Bosnia and Herzegovina" },
    { value: "+55", label: "Brazil" },
    { value: "+267", label: "Botswana" },
    { value: "+246", label: "British Indian Ocean Territory" },
    { value: "+1", label: "British Virgin Islands" },
    { value: "+673", label: "Brunei Darussalam" },
    { value: "+359", label: "Bulgaria" },
    { value: "+226", label: "Burkina Faso" },
    { value: "+855", label: "Cambodia" },
    { value: "+1", label: "Canada" },
    { value: "+238", label: "Cape Verde" },
    { value: "+1", label: "Cayman Islands" },
    { value: "+56", label: "Chile" },
    { value: "+61", label: "Christmas Island" },
    { value: "+269", label: "Comoros" },
    { value: "+682", label: "Cook Islands" },
    { value: "+506", label: "Costa Rica" },
    { value: "+225", label: "C\u00F4te d'Ivoire" },
    { value: "+385", label: "Croatia" },
    { value: "+357", label: "Cyprus" },
    { value: "+420", label: "Czech Republic" },
    { value: "+45", label: "Denmark" },
    { value: "+253", label: "Djibouti" },
    { value: "+1", label: "Dominica" },
    { value: "+1", label: "Dominican Republic" },
    { value: "+670", label: "Timor-Leste" },
    { value: "+593", label: "Ecuador" },
    { value: "+240", label: "Equatorial Guinea" },
    { value: "+372", label: "Estonia" },
    { value: "+251", label: "Ethiopia" },
    { value: "+500", label: "Falkland Islands (Malvinas)" },
    { value: "+298", label: "Faroe Islands" },
    { value: "+679", label: "Fiji" },
    { value: "+358", label: "Finland" },
    { value: "+33", label: "France" },
    { value: "+594", label: "French Guiana" },
    { value: "+689", label: "French Polynesia" },
    { value: "+241", label: "Gabon" },
    { value: "+220", label: "Gambia" },
    { value: "+995", label: "Georgia" },
    { value: "+49", label: "Germany" },
    { value: "+233", label: "Ghana" },
    { value: "+350", label: "Gibraltar" },
    { value: "+30", label: "Greece" },
    { value: "+299", label: "Greenland" },
    { value: "+1", label: "Grenada" },
    { value: "+590", label: "Guadeloupe" },
    { value: "+1", label: "Guam" },
    { value: "+502", label: "Guatemala" },
    { value: "+224", label: "Guinea" },
    { value: "+245", label: "Guinea-Bissau" },
    { value: "+592", label: "Guyana" },
    { value: "+852", label: "Hong Kong" },
    { value: "+36", label: "Hungary" },
    { value: "+354", label: "Iceland" },
    { value: "+91", label: "India" },
    { value: "+62", label: "Indonesia" },
    { value: "+353", label: "Ireland" },
    { value: "+972", label: "Israel" },
    { value: "+39", label: "Italy" },
    { value: "+1", label: "Jamaica" },
    { value: "+81", label: "Japan" },
    { value: "+44", label: "Jersey" },
    { value: "+962", label: "Jordan" },
    { value: "+7", label: "Kazakhstan" },
    { value: "+254", label: "Kenya" },
    { value: "+686", label: "Kiribati" },
    { value: "+82", label: "Republic of Korea" },
    { value: "+383", label: "Republic of Kosovo" },
    { value: "+965", label: "Kuwait" },
    { value: "+996", label: "Kyrgyzstan" },
    { value: "+856", label: "Lao People's Democratic Republic" },
    { value: "+371", label: "Latvia" },
    { value: "+266", label: "Lesotho" },
    { value: "+231", label: "Liberia" },
    { value: "+423", label: "Liechtenstein" },
    { value: "+370", label: "Lithuania" },
    { value: "+352", label: "Luxembourg" },
    { value: "+853", label: "Macau" },
    { value: "+389", label: "North Macedonia" },
    { value: "+261", label: "Madagascar" },
    { value: "+265", label: "Malawi" },
    { value: "+60", label: "Malaysia" },
    { value: "+960", label: "Maldives" },
    { value: "+356", label: "Malta" },
    { value: "+692", label: "Marshall Islands" },
    { value: "+596", label: "Martinique" },
    { value: "+230", label: "Mauritius" },
    { value: "+262", label: "Mayotte" },
    { value: "+52", label: "Mexico" },
    { value: "+691", label: "Federated States of Micronesia" },
    { value: "+373", label: "Republic of Moldova" },
    { value: "+377", label: "Monaco" },
    { value: "+976", label: "Mongolia" },
    { value: "+382", label: "Montenegro" },
    { value: "+1", label: "Montserrat" },
    { value: "+212", label: "Morocco" },
    { value: "+258", label: "Mozambique" },
    { value: "+264", label: "Namibia" },
    { value: "+674", label: "Nauru" },
    { value: "+977", label: "Nepal" },
    { value: "+31", label: "Netherlands" },
    { value: "+599", label: "Netherlands Antilles" },
    { value: "+687", label: "New Caledonia" },
    { value: "+64", label: "New Zealand" },
    { value: "+505", label: "Nicaragua" },
    { value: "+683", label: "Niue" },
    { value: "+672", label: "Norfolk Island" },
    { value: "+1", label: "Northern Mariana Islands" },
    { value: "+47", label: "Norway" },
    { value: "+968", label: "Oman" },
    { value: "+680", label: "Palau" },
    { value: "+507", label: "Panama" },
    { value: "+675", label: "Papua New Guinea" },
    { value: "+595", label: "Paraguay" },
    { value: "+51", label: "Peru" },
    { value: "+64", label: "Pitcairn" },
    { value: "+48", label: "Poland" },
    { value: "+351", label: "Portugal" },
    { value: "+1", label: "Puerto Rico" },
    { value: "+974", label: "Qatar" },
    { value: "+40", label: "Romania" },
    { value: "+250", label: "Rwanda" },
    { value: "+290", label: "Saint Helena, Ascension and Tristan da Cunha" },
    { value: "+1", label: "Saint Kitts and Nevis" },
    { value: "+1", label: "Saint Lucia" },
    { value: "+508", label: "Saint Pierre and Miquelon" },
    { value: "+1", label: "Saint Vincent and the Grenadines" },
    { value: "+685", label: "Samoa" },
    { value: "+378", label: "San Marino" },
    { value: "+239", label: "S\u00E3o Tom\u00E9 and Pr\u00EDncipe" },
    { value: "+221", label: "Senegal" },
    { value: "+381", label: "Serbia" },
    { value: "+248", label: "Seychelles" },
    { value: "+232", label: "Sierra Leone" },
    { value: "+65", label: "Singapore" },
    { value: "+421", label: "Slovakia" },
    { value: "+386", label: "Slovenia" },
    { value: "+677", label: "Solomon Islands" },
    { value: "+27", label: "South Africa" },
    { value: "+500", label: "South Georgia and the South Sandwich Islands" },
    { value: "+34", label: "Spain" },
    { value: "+94", label: "Sri Lanka" },
    { value: "+597", label: "Suriname" },
    { value: "+268", label: "Swaziland" },
    { value: "+46", label: "Sweden" },
    { value: "+41", label: "Switzerland" },
    { value: "+886", label: "Taiwan" },
    { value: "+992", label: "Tajikistan" },
    { value: "+255", label: "United Republic of Tanzania" },
    { value: "+228", label: "Togo" },
    { value: "+690", label: "Tokelau" },
    { value: "+676", label: "Tonga" },
    { value: "+1", label: "Trinidad and Tobago" },
    { value: "+216", label: "Tunisia" },
    { value: "+90", label: "Turkey" },
    { value: "+993", label: "Turkmenistan" },
    { value: "+1", label: "Turks and Caicos Islands" },
    { value: "+688", label: "Tuvalu" },
    { value: "+1", label: "U.S. Virgin Islands" },
    { value: "+256", label: "Uganda" },
    { value: "+971", label: "United Arab Emirates" },
    { value: "+44", label: "United Kingdom" },
    { value: "+1", label: "United States" },
    { value: "+598", label: "Uruguay" },
    { value: "+998", label: "Uzbekistan" },
    { value: "+678", label: "Vanuatu" },
    { value: "+379", label: "Holy See (Vatican City State)" },
    { value: "+84", label: "Vietnam" },
    { value: "+681", label: "Wallis and Futuna" },
    { value: "+260", label: "Zambia" }
];